import { Button, Modal, Typography } from 'components';
import { CloseIcon, ErrorModalFeaturedIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC, useRef } from 'react';
import { cn } from 'utils/cn';

interface IModalHubSpotDisconnect {
  open: boolean;
  onCancel: () => void;
  onClick?: () => void;
}

const ModalHubSpotDisconnect: FC<IModalHubSpotDisconnect> = ({ open, onCancel, onClick }) => {
  const t = useTranslations();

  const refModal = useRef<HTMLDivElement>(null);

  return (
    <Modal
      zDialog={cn('!z-[1999]')}
      zDialogBackdrop="z-[1000]"
      onClose={onCancel}
      open={open}
      className={'max-h-[60vh] w-[544px]'}
    >
      <div className="absolute right-2 top-2 z-[1000]">
        <Button
          size="small"
          variant="icon"
          color="neutral"
          className="!w-8 rounded-full"
          onClick={onCancel}
          startAdornment={<CloseIcon />}
        />
      </div>
      <div
        className={cn(
          'overflow-y-auto px-8 py-6',
          'relative flex w-full flex-col justify-center  gap-2 rounded bg-white shadow-custom'
        )}
        ref={refModal}
      >
        <ErrorModalFeaturedIcon />
        <Typography variant="medium4xl" className=" text-tertiary-100 ">
          {t('integrations.hubspot.disconnect.title')}
        </Typography>
        <Typography variant="light4" className="mt-2 flex">
          {t('integrations.hubspot.disconnect.paragraph')}
        </Typography>
        <div className="mt-4 flex justify-end gap-4">
          <Button
            size="medium"
            label={t('account_details.cancel')}
            onClick={onCancel}
            className="flex items-center"
            variant="text"
          />
          <Button
            size="medium"
            label={t('integrations.hubspot.disconnect.button')}
            onClick={onClick}
            color="danger"
            className="flex items-center"
            variant="contained"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalHubSpotDisconnect;
